import {
    type GetAllCommercialOpportunityRequestHistoriesResponseType,
    type GetAllCommercialOpportunityRequestHistoriesRequestType
} from "./type";
import {
    request
} from "../request";

const getAllCommercialOpportunityRequestHistories = async (
    params: GetAllCommercialOpportunityRequestHistoriesRequestType
): Promise<GetAllCommercialOpportunityRequestHistoriesResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.reason) {
        searchParams.append("reason", params.reason);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllCommercialOpportunityRequestHistories?${queryStr}` : "/request/getAllCommercialOpportunityRequestHistories";

    return await request<GetAllCommercialOpportunityRequestHistoriesResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllCommercialOpportunityRequestHistories;
